<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="!windowService.isDesktopRes"
      [title]="'Properties'"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-image
            style="z-index: 1000"
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Properties'" />
          @if (!isEditPropertiesEnabled) {
            <form [formGroup]="form" novalidate action="#">
              <tidy-search-input
                formControlName="search"
                [placeholder]="'Search'"
                [icon]="'assets/img/search-header.svg'"
                class="header-search" />
            </form>
          }
          <tidy-small-button
            [text]="'Add Property'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToAddAddress()" />
          <div style="display: flex; justify-content: flex-end; align-items: center; margin-left: auto;">
            <tidy-text [body]="'Edit Order'" />
            <tidy-toggle
              [toggled]="isEditPropertiesEnabled"
              (toggleChanged)="onToggleChange()"
              class="extra-left-margin" />
          </div>
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      <div [class.addresses-scrollable-content]="windowService.isDesktopRes">
        @if (!windowService.isDesktopRes) {
          <tidy-row>
            <tidy-button
              [text]="'Add Property'"
              [action]="boundGoToAddAddress"
              class="primary full-width" />
          </tidy-row>
        }
        @if (!windowService.isDesktopRes) {
          <tidy-row
            [alignLastItemRight]="true"
            style="display: flex; justify-content: center">
            <tidy-text [body]="'Edit Order'" />
            <tidy-toggle
              [toggled]="isEditPropertiesEnabled"
              (toggleChanged)="onToggleChange()"
              class="extra-left-margin" />
          </tidy-row>
        }
        @if (!isEditPropertiesEnabled && !windowService.isDesktopRes) {
          <tidy-alert class="mobile-search-alert">
            <form [formGroup]="form" novalidate action="#">
              <tidy-row class="field-top-padding" style="padding-bottom: 0px">
                <tidy-search-input
                  formControlName="search"
                  [placeholder]="'Searchss'"
                  [icon]="'assets/svg/search.svg'" />
              </tidy-row>
            </form>
          </tidy-alert>
        }
        @if (addresses?.length > 0) {
          <tidy-drag-drop
            dragDropId="addresses-dd"
            [dataList]="addresses"
            emptyListColor="green"
            emptyListMessage="Drag to add to list."
            [disabled]="!isEditPropertiesEnabled"
            (listDropped)="updateAddresses($event)">
            @for (address of addresses; track address; let last = $last) {
              <ng-container *tidyDragDropItem>
                @if (isEditPropertiesEnabled) {
                  <tidy-card>
                    @if (!address?.address_name) {
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          class="header-size"
                          style="position: absolute; margin-top: 23px"
                          [src]="'assets/svg/menu-tidy-green.svg'" />
                        <tidy-text
                          style="padding-left: 25px"
                          [body]="address?.address1 + ' '"
                          [translate]="false" />
                      </tidy-row>
                      @if (address?.address2 !== null && address?.address2 !== '') {
                        <tidy-row
                          style="padding-left: 25px"
                          >
                          <tidy-text [body]="address?.address2" />
                        </tidy-row>
                      }
                      <tidy-row style="padding-left: 25px">
                        @if (address?.city !== null && address?.city !== '') {
                          <tidy-text
                            [helper]="address?.city" />
                        }
                        @if (address?.zip !== null && address?.zip !== '') {
                          <tidy-text
                            [helper]="', ' + address?.zip" />
                        }
                      </tidy-row>
                    }
                    @if (address?.address_name) {
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          class="header-size"
                          [src]="'assets/svg/menu-tidy-green.svg'"
                          [style]="address?.integration?.name ? 'position: absolute; margin-top: 23px' : ''" />
                        <tidy-text
                          [body]="address?.address_name"
                          [translate]="false"
                          [style]="address?.integration?.name ? 'padding-left: 25px' : ''" />
                      </tidy-row>
                    }
                    @if (address?.integration?.name) {
                      <tidy-row style="padding-left: 25px">
                        <tidy-text [helper]="'Synced with '" />
                        <tidy-text
                          [helper]="address?.integration?.name"
                          [translate]="false" />
                        <tidy-text [helper]="' (' + address.integration.state + ')'" />
                      </tidy-row>
                    }
                  </tidy-card>
                }
              </ng-container>
            }
          </tidy-drag-drop>
        }
      @if (!isEditPropertiesEnabled) {
        @for (address of addresses; track address; let last = $last) {
          <tidy-card>
            <tidy-card-button (action)="goToEditAddress(address)">
              @if (!address?.address_name) {
                <tidy-row>
                  <tidy-tag
                    [color]="address?.color"
                    [addressId]="address?.id" />
                  <tidy-text [body]="address?.address1 + ' '" [translate]="false" />
                </tidy-row>
                @if (address?.address2 !== null && address?.address2 !== '') {
                  <tidy-row
                    >
                    <tidy-text [body]="address?.address2" />
                  </tidy-row>
                }
                <tidy-row>
                  @if (address?.city !== null && address?.city !== '') {
                    <tidy-text
                      [helper]="address?.city" />
                  }
                  @if (address?.zip !== null && address?.zip !== '') {
                    <tidy-text
                      [helper]="', ' + address?.zip" />
                  }
                </tidy-row>
              }
              @if (address?.address_name) {
                <tidy-row>
                  <tidy-tag
                    [color]="address?.color"
                    [addressId]="address?.id" />
                  <tidy-text [body]="address?.address_name" [translate]="false" />
                </tidy-row>
              }
              @if (address?.integration?.name) {
                <tidy-row>
                  <tidy-text [helper]="'Synced with'" /><span>&nbsp;</span>
                  <tidy-text
                    [helper]="address?.integration?.name"
                    [translate]="false" />
                  <tidy-text [helper]="' (' + address.integration.state + ')'" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
      }
      @if (addresses?.length == 0) {
        <tidy-alert>
          <tidy-text
            [body]="'No results'" />
        </tidy-alert>
      }
      </div>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
